<template>
  <v-data-table
    :pagination.sync="pagination"
    :headers="headers"
    :items="articles"
    class="elevation-1"
    v-if="articles"
  >
    <template v-slot:items="props">
      <tr>
        <td>
          <v-btn
            :to="{name:'articleEdit', params:{id:props.item.articleId}}"
            small
          >{{ props.item.articleId }}</v-btn>
        </td>
        <td>
          <v-btn
            :to="{name:'articleEdit', params:{id:props.item.parentId}}"
            v-if="props.item.parentId"
            small
          >{{ props.item.parentId }}</v-btn>
        </td>
        <td>{{ props.item.heading }}</td>
        <td>{{ props.item.title }}</td>
        <td>{{ props.item.description }}</td>
        <td>{{ props.item.created | formatDateTime }}</td>
        <!-- <td>
            <span v-html="props.item.body" />
        </td>-->
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "Articles",
  props: ["articles"],
  data() {
    return {
      headers: [
        {
          text: "Id",
          value: "articleId"
        },
        {
          text: "Parent id",
          value: "parentId"
        },
        {
          text: "Heading",
          value: "heading"
        },
        {
          text: "Title",
          value: "title"
        },
        {
          text: "Description",
          value: "description"
        },
        {
          text: "Created",
          value: "created"
        }
        // {
        //   text: "Body",
        //   value: "body"
        // }
      ],
      pagination: {
        rowsPerPage: -1
      }
    };
  }
};
</script>